import { render, staticRenderFns } from "./PasswordResetByToken.vue?vue&type=template&id=5e321556&"
import script from "./PasswordResetByToken.vue?vue&type=script&lang=js&"
export * from "./PasswordResetByToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports